module.exports = __webpack_public_path__ + "079296a13c4f76ca97994bc6086dfa28.jpg";